export default {
    path: global.isProd
        ? "buildServer/server/models/slp/mails"
        : "src/server/models/slp/mails"
}
